<div class="popuppadding">
  <button mat-icon-button class="close-button" (click)="onNoClick()">
    <mat-icon class="close-icon" color="black">close</mat-icon>
  </button>

  <h2 class="width" matDialogTitle>Warning</h2>
  <mat-dialog-content>
    <span><mat-icon class="paddingtop">warning</mat-icon></span><span class="padding-left">{{data.message}}</span>

  </mat-dialog-content>
  <mat-dialog-actions class="btn-align">

    <button mat-raised-button (click)="onNoClick()" color="primary">Cancel</button>
    <button mat-raised-button (click)="regist()" color="warn">Override Session</button>
  </mat-dialog-actions>
</div>
